@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">{{ config.title }}</h1>

<mat-card class="simulator-card">
  <div class="simulator-content">
    <div class="simulator-layout">
      <div class="simulator-column">
        <app-rock-preview
          [thumbnailUrl]="thumbnailUrl"
          [totalPorosity]="totalPorosity"
          [showLegend]="false"
          [imageLabel]="'Upscaling Rock Image'"
          [porosityLabel]="'Total Porosity:'"
          [showPorosity]="shouldShowPorosity">
        </app-rock-preview>
      </div>

      <div class="simulator-column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Select Segmented Upscaling image</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="input-row">
            <div class="flex">
              <mat-form-field appearance="outline">
                <mat-label>Segmented Rock Image</mat-label>
                <input matInput [formControl]="fileName" />
              </mat-form-field>
              <button
                class="btn btn-primary upload-btn"
                (click)="selectRockFileName()"
                >
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Select rock model</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="input-row">
            <div class="flex">
              <mat-form-field appearance="outline">
                <mat-label>Rock model</mat-label>
                <input matInput [value]="rockModelName" readonly />
              </mat-form-field>
              <button
                class="btn btn-primary upload-btn"
                (click)="selectRockModel()"
                [disabled]="rockModelControl.disabled || isLoadingRockModels"
                >
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Simulation name</mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="simulationNameForm">
            <mat-form-field appearance="outline" class="form-input">
              <mat-label>Simulation name</mat-label>
              <input matInput [formControlName]="'name'" />
              @if (nameControl.hasError('maxlength')) {
                <mat-error>
                  Simulation name can't contain more than 256 characters.
                </mat-error>
              }
            </mat-form-field>
          </form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Simulation directions</mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="simulationDirectionsForm">
            <div class="input-row">
              <span>Simulation Directions</span>
              <div class="direction-options">
                <mat-checkbox formControlName="xDirection">X</mat-checkbox>
                <mat-checkbox formControlName="yDirection">Y</mat-checkbox>
                <mat-checkbox formControlName="zDirection">Z</mat-checkbox>
              </div>
            </div>
          </form>
        </mat-expansion-panel>

        <div class="controls">
          <button
            class="btn btn-primary btn-big min-w-350"
            type="button"
            [disabled]="this.isLoading || !isSimulationInputValid()"
            (click)="runSimulation()"
            color="primary"
            >
            Run simulation
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-card>
